"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHolderDelegateRoleSerializer = exports.HolderDelegateRole = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
var HolderDelegateRole;
(function (HolderDelegateRole) {
    HolderDelegateRole[HolderDelegateRole["PrintDelegate"] = 0] = "PrintDelegate";
})(HolderDelegateRole = exports.HolderDelegateRole || (exports.HolderDelegateRole = {}));
function getHolderDelegateRoleSerializer() {
    return (0, serializers_1.scalarEnum)(HolderDelegateRole, {
        description: 'HolderDelegateRole',
    });
}
exports.getHolderDelegateRoleSerializer = getHolderDelegateRoleSerializer;
//# sourceMappingURL=holderDelegateRole.js.map